import { createContext } from 'react';
import { QUERY_KEYS_CIHA, useChartsData } from '../../Common/hooks/useChartsData';
import { useCIHAFiltersContext } from '../../Common/Filters/hooks/useCIHAFiltersContext';

export const ProductionTemporalChartsDataContext = createContext();

const ProductionTemporalChartsDataProvider = ({ children }) => {
    const { filters } = useCIHAFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
        cnes: filters.unidade?.value,
        ano: filters.year?.value || currentYear,
        mes: filters.month?.value
    };

    const temporalEvolution = useChartsData(
        {
            key: QUERY_KEYS_CIHA.PRODUCTION_TEMPORAL_EVOLUTION,
            url: 'governanceroom/cihadashboard/productionTemporalEvolution'
        },
        filterParams,
        true
    );

    const byMonth = useChartsData(
        {
            key: QUERY_KEYS_CIHA.PRODUCTION_BY_MONTH,
            url: 'governanceroom/cihadashboard/productionByMonth'
        },
        filterParams
    );

    const monthlySeries = useChartsData(
        {
            key: QUERY_KEYS_CIHA.PRODUCTION_MONTHLY_SERIES,
            url: 'governanceroom/cihadashboard/productionMonthlySeries'
        },
        filterParams,
        true
    );

    const permanenceDistribution = useChartsData(
        {
            key: QUERY_KEYS_CIHA.PRODUCTION_PERMANENCE_DISTRIBUTION,
            url: 'governanceroom/cihadashboard/productionPermanenceDistribution'
        },
        filterParams
    );

    const avgPermanence = useChartsData(
        {
            key: QUERY_KEYS_CIHA.PRODUCTION_AVG_PERMANENCE,
            url: 'governanceroom/cihadashboard/productionAvgPermanence'
        },
        filterParams,
        true
    );

    const queries = [temporalEvolution, byMonth, monthlySeries, permanenceDistribution, avgPermanence];
    const isLoading = queries.some((query) => query.isLoading);
    const isError = queries.some((query) => query.isError);

    const chartData = {
        temporalEvolution: temporalEvolution.data?.por_ano || {},
        byMonth: byMonth.data?.por_mes || {},
        monthlySeries: monthlySeries.data?.serie_mensal || {},
        permanenceDistribution: permanenceDistribution.data?.dist_perm || {},
        avgPermanence: avgPermanence.data?.media_perm_ano || {}
    };

    return (
        <ProductionTemporalChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters
            }}
        >
            {children}
        </ProductionTemporalChartsDataContext.Provider>
    );
};

export default ProductionTemporalChartsDataProvider;
